export const API_URL = 'https://api.plastik.teko-dev.com/api/';
//export const API_URL = window.location.hostname == 'localhost' ? 'http://localhost/plastik/api/' : 'https://api.plastik.teko-dev.com/api/';
export const APP_URL = window.location.hostname != 'localhost' ? 'localhost:8080/' :'https://plastik.teko-dev.com';
export const APP_PREFIX = 'plastik';

export const USER_ROLES = [
    {role: 'administrador', label: 'Administrador'},
    {role: 'coordinador', label: 'Coordinador'},
    {role: 'supervisor', label: 'Supervisor'}
];